import { render, staticRenderFns } from "./QualityPolicy.vue?vue&type=template&id=457b5664&"
import script from "./QualityPolicy.vue?vue&type=script&lang=js&"
export * from "./QualityPolicy.vue?vue&type=script&lang=js&"
import style0 from "./QualityPolicy.vue?vue&type=style&index=0&id=457b5664&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports